export default "__VITE_ASSET__BfAQtN_y__"